import { toInternalPath } from './internal-path';
import { rememberSocialHandoff, type SocialProvider } from './social-handoff';

/**
 * 왜 나가는가.
 *
 * `login` 은 로그인·가입이고, `link` 는 **이미 로그인한 계정에 소셜을 붙이는 것**이다.
 * 서버가 이 값을 state 에 담아 두었다가 돌아왔을 때 본다 — 없으면 이메일로 판정해야
 * 하는데, 카카오 이메일과 서비스 계정 이메일이 다른 사람이 아주 흔해서 그 판정이 틀린다.
 */
type SocialIntent = 'login' | 'link';

/**
 * 제공자에게 보낸다.
 *
 * 라우터가 아니라 `window.location` 을 쓰는 이유: 카카오·네이버는 **다른 사이트**다.
 * SPA 라우터는 우리 앱 안에서만 움직이므로 여기서는 쓸 수 없다.
 *
 * 쪽지를 먼저 남긴다 — 이동이 시작되면 이 탭의 스크립트는 더 이상 돌지 않는다.
 *
 * 목적을 주소창에 싣는 것이 안전한 이유: 위조해도 얻는 것이 없다. `link` 로 시작하면
 * 콜백은 로그인시키지 않고 티켓만 주고, 그 티켓으로 실제 연결을 하는 `auth.social.link`
 * 는 액세스 토큰을 요구하므로 붙는 곳은 언제나 부른 사람 자신의 계정이다.
 */
export const startSocialLogin = (
  provider: SocialProvider,
  next: string,
  intent: SocialIntent = 'login',
): void => {
  rememberSocialHandoff({ provider, next: toInternalPath(next) });
  window.location.href = socialStartUrl(provider, intent);
};

/**
 * 나갈 주소. 이동과 나눠 둔 이유는 **jsdom 이 실제 이동을 구현하지 않아서**다 —
 * `window.location.href` 를 읽어 확인할 수 없으므로, 주소를 만드는 판단만 따로 검증한다.
 */
export const socialStartUrl = (provider: SocialProvider, intent: SocialIntent = 'login'): string =>
  // 기본값일 때는 붙이지 않는다 — 기존 주소를 그대로 두어 무엇이 달라졌는지 드러낸다.
  intent === 'link' ? `/auth/${provider}?intent=link` : `/auth/${provider}`;
